<template>
  <div class="fzmLoginWrapper registerWrap">
    <div class="container">
        <div class="row">
            <div class="col-md-5">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <a class="navbar-brand" href=".">
                        <img src="@/assets/img/logo.svg" alt="">
                    </a>
                </nav>
                
                <div class="loginForm">
                    <h1>We're excited you're here</h1>

                    <b-row>
                        <b-col cols="6">
                            <input 
                                v-model="regform.first_name"
                                :name="`${Math.random()}register`"
                                :autocomplete="`${Math.random()}register`" 
                                type="text" 
                                placeholder="First Name" 
                                class="form-control inputFilled mb-3">
                        </b-col>
                        <b-col cols="6">
                            <input 
                                v-model="regform.last_name"
                                :name="`${Math.random()}register`"
                                :autocomplete="`${Math.random()}register`" 
                                type="text" 
                                placeholder="Last Name" 
                                class="form-control inputFilled mb-3">
                        </b-col>
                    </b-row>
    

                    <input 
                        v-model="regform.phone_number"
                        :name="`${Math.random()}register`"
                        :autocomplete="`${Math.random()}register`" 
                        type="tel" 
                        placeholder="Phone Number" 
                        class="form-control inputFilled mb-3">

                    <input 
                        v-model="regform.email"
                        type="text" 
                        placeholder="Email" 
                        @input="invalidemail = false"
                        :name="`${Math.random()}register`"
                        :autocomplete="`${Math.random()}register`" 
                         :class="['form-control inputFilled mb-3', {'is-invalid' : invalidemail}]">

                    <input 
                        @input="validatepassword"
                        v-model="regform.password"
                        :name="`${Math.random()}register`"
                        :autocomplete="`${Math.random()}register`" 
                        type="password" 
                        placeholder="Password" 
                        :class="['form-control inputFilled mb-3', {'is-invalid' : passworderror}]">
                        
                  
                    <input 
                        @input="validatepassword"
                        v-model="regform.c_password"
                        :name="`${Math.random()}register`"
                        :autocomplete="`${Math.random()}register`" 
                        type="password" 
                        placeholder="Confirm Password" 
                        :class="['form-control inputFilled mb-3', {'is-invalid' : passworderror}]">

                    <div class="streetwrapper">
                        <input 
                            id="autocompletesbox"
                            v-model="regform.street_address"
                            :name="`${Math.random()}register`"
                            :autocomplete="`${Math.random()}register`" 
                            type="text" 
                            placeholder="Street Address" 
                            :class="['form-control inputFilled mb-3']">

                            <!-- <b-list-group v-show="places.length > 0">
                                <template v-for="place in places">
                                    <b-list-group-item 
                                        @click="selectaddress(place)"
                                        :key="place.place_id"> 
                                        <b-icon icon="geo-alt-fill"></b-icon> {{place.formatted_address}}
                                    </b-list-group-item>
                                </template>
                            </b-list-group> -->
                    </div>
                    

                    <b-row class="mb-3">
                        <b-col cols="5">
                            <input 
                                readonly
                                v-model="regform.city"
                                :name="`${Math.random()}register`"
                                :autocomplete="`${Math.random()}register`" 
                                placeholder="City"
                                class="form-control inputFilled"
                                type="text">
                        </b-col>

                        <b-col cols="2">
                            <input 
                                disabled
                                v-model="regform.state"
                                placeholder="City"
                                class="form-control inputFilled"
                                type="text">
                        </b-col>

                        <b-col cols="5">
                            <input 
                                readonly
                                v-model="regform.zip_code"
                                :name="`${Math.random()}register`"
                                :autocomplete="`${Math.random()}register`" 
                                placeholder="Zip Code"
                                class="form-control inputFilled"
                                type="text">
                        </b-col>
                    </b-row>



                    <div class="row">
                        <div class="col-8">
                            <a 
                                @click.prevent="$router.push({name : 'login'})"
                                href="#">Already have an account? Log In</a>
                        </div>
                        <div class="col-4">
                            <button 
                                :disabled="!validateflds"
                                @click.prevent="register"
                                class="btn btn-primary">
                                SIGN UP
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="col-md-7">
                <div class="loginImage">
                    
                </div>
            </div>
        </div>
    </div>

    <b-modal 
        @hidden="$router.push({name : 'home'})"
        id="registersuccess" 
        hide-footer hide-header>
        <div class="d-block text-center mt-5">
            <h3><b-icon icon="person"></b-icon></h3>
            <h3>Registered</h3>

            <p>Verification link is sent to your email address <span class="emailaddress">{{regform.email}}</span>.</p>
        </div>
        <b-button 
            class="mt-4 mb-5" 
            variant="primary"  
            block 
            @click="editdeliveryday = false, $bvModal.hide('registersuccess')">Continue</b-button>
    </b-modal>
</div>
</template>

<script>
/**
 * declerations
 */

// Plugins
import axios from 'axios'

// Helpers
// import Helper from '@/helpers/helper'

// Mixins
import {gmapmixins} from '@/mixins/gmapmixins'

export default {
    mixins : [gmapmixins],
    data() {
        return {
            regform      : {
                first_name       : '',
                last_name        : '',
                email            : '',
                password         : '',
                c_password       : '',
                phone_number     : '',
                street_address   : '',
                city             : '',
                zip_code         : '',
                address_latitude : '',
                address_longitude: '',
                state            : 'UT'  // State will default to UT
            },
            passworderror: true,
            processing   : false,
            invalidemail : false
        }
    },
    computed : {
         /**
         * Validate fields if empty or missing fld value
         */
        validateflds() {
            let validated = true;

            if(this.passworderror) {
                validated = false;
            } 
            else if(!this.regform.first_name) {
                validated = false;
            }
            else if(!this.regform.last_name) {
                validated = false;
            }
            else if(!this.regform.phone_number) {
                validated = false;
            }
            else if(!this.regform.email) {
                validated = false;
            }
            else if(!this.regform.password) {
                validated = false;
            }
            else if(!this.regform.address_latitude) {
                validated = false;
            }
            else if(!this.regform.address_longitude) {
                validated = false;
            }
            else if(this.processing) {
                validated = false;
            }

            return validated;
        }
    },
    methods : {
        /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress() {
            const inputbox = document.getElementById('autocompletesbox');
            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {
                        /**
                         * get latitude and longtitude
                         */
                        this.regform.address_latitude  = data.geometry.location.lat();
                        this.regform.address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        const streetnumber               = data.address_components.find(d => d.types.includes('street_number'));
                        const street                     = data.address_components.find(d => d.types.includes('street'));
                        const route                      = data.address_components.find(d => d.types.includes('route'));
                        
                        this.regform.street_address = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city              = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              this.regform.city = city.long_name;

                        // get state
                        const state              = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              this.regform.state = state.short_name;

                        // get postal_code
                        const postalcode            = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              this.regform.zip_code = postalcode.short_name;
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        },
        /** 
        * User registration
        * @param  {Object}
        */
        async register() {
            this.processing = true;
            await axios.post(`/register`, this.regform).then(res => {
                const data = res.data;
                
                /**
                 * Registration token will saved to cookie
                 * then redirect to dashboard 
                 */
                if(data.success) {
                    // Helper.setCookie('holeswebtoken', data.token, 1);
                    // Helper.axoisglobalconfig();
                    // this.$router.push({name : 'home'})
                    this.$bvModal.show("registersuccess");
                } else {
                    this.invalidemail = true;
                }
                

            }).catch(err => {
                console.log('error registration', err)
                this.invalidemail = true;
            });

            // reset
            this.processing = false;
        },
        /**
         * Password validation
         * Check if password and confirm password is match
         */
        validatepassword() {
            if(this.regform.password !==  this.regform.c_password) {
                this.passworderror = true;
            } else {
                this.passworderror = false;
            }
        },
       
    },
    beforeMount() {
        /**
         * Run function before component render
         */

       
    },
    mounted() {
        /**
         * Run functions after component redered
         */

        // initiate address autocomplete
        // Initiate google map 
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
            this.autocompleteaddress();
        });
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';
#registersuccess {
    .emailaddress {
        color      : $primary-color;
        font-weight: 700;
    }
}

.registerWrap {
    .form-control {
        border      : 1px solid $light-gray !important;
        padding-left: 15px !important;

        &:disabled {
            background-color: transparent;
            border-color    : transparent !important;
            color           : $primary-color;
            padding         : 0;
        }
        
    }

    .streetwrapper {
        position : relative;
        .list-group {
            position: absolute;
            z-index : 100;
            top     : calc(1.5em + 0.75rem + 2px);
        
        }
    }
}
</style>